import { useState } from "react";
import { apiJson } from "../api/client";
import { useLocale } from "../contexts/LocaleContext";

export function ReferralLink() {
  const { t } = useLocale();
  const [url, setUrl] = useState("");
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState("");
  const generate = async () => {
    setBusy(true); setMessage("");
    try {
      const data = await apiJson<{ url: string }>("/user/referral-link");
      const source = new URL(data.url);
      // Keep local test links on the local site; production stays on its own host.
      setUrl(new URL(`${source.search}#/register`, window.location.origin).href);
    }
    catch { setMessage(t("referral.error")); }
    finally { setBusy(false); }
  };
  return <section className="referral-link">
    <h2>{t("referral.title")}</h2><p>{t("referral.intro")}</p>
    <button type="button" disabled={busy} onClick={generate}>{t("referral.generate")}</button>
    {url && <><label>{t("referral.link")}<input type="text" readOnly value={url} onFocus={e => e.target.select()} /></label>
      <button type="button" onClick={async () => {
        try { await navigator.clipboard.writeText(url); setMessage(t("referral.copied")); }
        catch { setMessage(t("referral.copyManually")); }
      }}>{t("referral.copy")}</button></>}
    {message && <p role="status">{message}</p>}
  </section>;
}
